import { render, staticRenderFns } from "./AddClientDiaspora.vue?vue&type=template&id=642601f0&"
import script from "./AddClientDiaspora.vue?vue&type=script&lang=js&"
export * from "./AddClientDiaspora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports